import { Component } from "react";
import CustomizedTextField from "../../Input/CustomizedTextField";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { clone } from "../../../utils";

class FormMatrixHeaderField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.surveyResponseAnswer.answer,
            timeout: 1,
            typedJustNow: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.typedJustNow) return state;

        state.value = props.surveyResponseAnswer.answer;
        return state;
    }

    handleChange(e) {
        let value = e.target.value;

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            value,
            typedJustNow: true,
            typingTimeout: setTimeout(() => {
                let surveyResponseAnswer = clone(this.props.surveyResponseAnswer);

                surveyResponseAnswer.answer = value;

                this.props.responseValueChange(surveyResponseAnswer);

                this.setState({
                    typedJustNow: false,
                });
            }, this.state.timeout),
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <CustomizedTextField
                onChange={this.handleChange.bind(this)}
                value={this.state.value}
                className={"full_size control-margin-top " + (this.props.disabled ? "light-disabled" : "")}
            />
        );
    }
}

export default FormMatrixHeaderField;
